import create from "zustand";

const __default_bath_state = {
    id: 0,
    basic: [],
    addon: [],
};

export const __default_store_state = {
    estimate_info: {
        package_final_price: 0,
        basic: [],
        addon: [],
        bath: [],
        hardware: [],
        option: [],
        promotion: [],
    },
};

export const __default_fk_store_state = {
    estimate_info: {
        hardware: [],
        option: [],
    },
};

export const useEstimateStore = create((set) => ({
    estimate_info: __default_store_state.estimate_info,
    setEstimateInfo: (_project) =>
        set((state) => {
            return {
                ...state,
                estimate_info: { ..._project },
            };
        }),
    resetStore: () =>
        set((state) => {
            return __default_store_state;
        }),
}));

export const useFiveKitchenEstimateStore = create((set) => ({
    estimate_info: __default_fk_store_state.estimate_info,
    setEstimateInfo: (_project) =>
        set((state) => {
            return {
                ...state,
                estimate_info: { ..._project },
            };
        }),
    resetStore: () =>
        set((state) => {
            return __default_fk_store_state;
        }),
}));
